import React, { useState, useEffect } from 'react';
import { Modal, Button, Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import Styles from '../../../styles/common/pages.module.css';
import Style from '../../../styles/pages/girls-fashion/girls-fashion.module.css';
import { useNavigate } from 'react-router-dom';

const GirlsFashion = () => {
    const [showModal, setShowModal] = useState(false);
    const [selectedAgeRange, setSelectedAgeRange] = useState('');
    // Navigation hook for programmatic navigation within React Router.
    const navigate = useNavigate()

    useEffect(() => {
        // Show modal on mount
        setShowModal(true);
    }, []);

    const handleAgeRangeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedAgeRange(e.target.value);
    };

    const handleSubmit = () => {
        console.log("Selected age range:", selectedAgeRange);
        setShowModal(false);

        // Navigate to age-based route
        if (selectedAgeRange) {
            navigate(`/girls-fashion/${selectedAgeRange}`);
        }
    };

    const handleClose = () => {
        setShowModal(false);
        navigate('/')
    }
    return (
        <>
            {/* SEO Meta Tags */}
            <Helmet>
                <title>Girls Fashion - Mohit's Shopping App</title>
                <meta
                    name="description"
                    content="Explore the latest girls fashion by age range. Choose from dresses, accessories, and more!"
                />
                <meta property="og:title" content="Girls Fashion - Mohit's Shopping App" />
                <meta
                    property="og:description"
                    content="Explore the latest girls fashion by age range. Choose from dresses, accessories, and more!"
                />
                <meta
                    property="og:image"
                    content={`${process.env.PUBLIC_URL}/favicon.png`}
                />
                <meta
                    property="og:url"
                    content="https://mohit-online-shopping.netlify.app/girls-fashion"
                />
            </Helmet>
            {/* Main Heading of the Home Page */}
            <h1 className="visually-hidden">Home - Online Shopping App & Website</h1>
            {/* This is the First Section of Home Page */}
            <section className={Styles.headSec}>
                <Container>
                    <h2>Girls Fashion</h2>
                </Container>
            </section>

            {/* Age Selection Modal */}
            <Modal show={showModal} backdrop="static" onHide={handleClose} centered contentClassName={Style.modalCustom}>
                <Modal.Header className={Styles.headSec} closeButton>
                    <Modal.Title >Select Age Range</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <select
                        className={`form-select ${Style.modalSelect}`}
                        value={selectedAgeRange}
                        onChange={handleAgeRangeChange}
                    >
                        <option value="">Select age range</option>
                        <option value="2-6">2 - 6 years</option>
                        {/* <option value="7-11">7 - 11 years</option>
                        <option value="12-14">12 - 14 years</option>
                        <option value="15-18">15 - 18 years</option>
                        <option value="19-24">18 - 24 years</option> */}
                    </select>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" className={Style.cancelBtn} onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={!selectedAgeRange}
                        className={Style.contBtn}
                    >
                        Continue
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default GirlsFashion;












// import React, { useState, useEffect } from 'react';
// import { Modal, Button } from 'react-bootstrap';

// const GirlsFashion = () => {
//     const [showModal, setShowModal] = useState(false);
//     const [selectedAgeRange, setSelectedAgeRange] = useState('');

//     useEffect(() => {
//         // Open modal when component mounts
//         setShowModal(true);
//     }, []);

//     const handleAgeRangeChange = (e: any) => {
//         setSelectedAgeRange(e.target.value);
//     };

//     const handleSubmit = () => {
//         console.log("Selected age range:", selectedAgeRange);
//         setShowModal(false);
//     };

//     const handleClose = () => setShowModal(false);

//     return (
//         <>
//             <Modal show={showModal} onHide={handleClose} centered>
//                 <Modal.Header closeButton>
//                     <Modal.Title>Select Age Range</Modal.Title>
//                 </Modal.Header>

//                 <Modal.Body>
//                     <select
//                         className="form-select"
//                         value={selectedAgeRange}
//                         onChange={handleAgeRangeChange}
//                     >
//                         <option value="">Select age range</option>
//                         <option value="1-3">1 - 3 years</option>
//                         <option value="4-6">4 - 6 years</option>
//                         <option value="7-9">7 - 9 years</option>
//                         <option value="10-12">10 - 12 years</option>
//                         <option value="13-15">13 - 15 years</option>
//                     </select>
//                 </Modal.Body>

//                 <Modal.Footer>
//                     <Button variant="secondary" onClick={handleClose}>
//                         Close
//                     </Button>
//                     <Button variant="primary" onClick={handleSubmit}>
//                         Continue
//                     </Button>
//                 </Modal.Footer>
//             </Modal>

//             <div className="p-4">
//                 <h1 className="text-2xl font-bold">Girls Fashion</h1>
//                 {selectedAgeRange && (
//                     <p>Showing products for age range: {selectedAgeRange} years</p>
//                 )}
//             </div>
//         </>
//     );
// };

// export default GirlsFashion;
